import React, { useState } from 'react';
//import './Chat.scss';

const Chat = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [textMessage, setTextMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [users] = useState([
    { id: 1, username: 'User1' },
    { id: 2, username: 'User2' },
    { id: 3, username: 'User3' },
  ]);

  const handleUserSelect = (user) => {
    setSelectedUser(user);
    // Fetch chat history between users (replace with actual API call)
    // const chatHistory = fetchChatHistory(currentUser.id, user.id);
    // setMessages(chatHistory);
  };

  const sendTextMessage = () => {
    if (!selectedUser) return;

    const newMessage = {
      id: messages.length + 1,
      senderId: selectedUser.id,
      text: textMessage,
    };

    setMessages([...messages, newMessage]);
    setTextMessage('');

    // In a real application, you should send the message to your server using an API call here
    // Example: sendTextMessage(selectedUser.id, textMessage);
  };

  return (
    <div className="chat-container">
      <div className="user-list">
        <h2>Users</h2>
        <ul>
          {users.map((user) => (
            <li key={user.id}>
              <button onClick={() => handleUserSelect(user)}>{user.username}</button>
            </li>
          ))}
        </ul>
      </div>
      <div className="message-display">
        {selectedUser ? (
          <>
            <h2>Chat with {selectedUser.username}</h2>
            <div className="message-list">
              {messages.map((message) => (
                <div
                  key={message.id}
                  className={`message ${message.senderId === selectedUser.id ? 'sent' : 'received'}`}
                >
                  <div className="message-container">{message.text}</div>
                </div>
              ))}
            </div>
            <div className="message-input">
              <input
                type="text"
                placeholder="Type your message..."
                value={textMessage}
                onChange={(e) => setTextMessage(e.target.value)}
              />
              <button onClick={sendTextMessage}>Send</button>
            </div>
          </>
        ) : (
          <p>Select a user to start chatting.</p>
        )}
      </div>
    </div>
  );
};

export default Chat;
